export default "__VITE_ASSET__b604725f__"